import { LocaleLanguage } from '@app/+authenticated/shared/locale/locale.helper';

export enum DemoType {
  ABSENCE_MANAGEMENT = 'ABSENCE_MANAGEMENT',
  OPTIMIZED_SCHEDULE = 'OPTIMIZED_SCHEDULE',
  TIME_TRACKING = 'TIME_TRACKING',
}

const supportedLanguageDemos = [LocaleLanguage.ENGLISH, LocaleLanguage.DUTCH, LocaleLanguage.GERMAN] as const;

export type SupportedLanguageDemo = (typeof supportedLanguageDemos)[number];

const supportedLanguageDemoSet = new Set<string>(supportedLanguageDemos);

export const isSupportedLanguageDemo = (language: string): language is SupportedLanguageDemo =>
  supportedLanguageDemoSet.has(language);

type DemosByLanguage = Record<SupportedLanguageDemo, string>;

export const ARCADE_DEMOS: Record<DemoType, DemosByLanguage> = {
  [DemoType.ABSENCE_MANAGEMENT]: {
    [LocaleLanguage.ENGLISH]: 'dqUHvWAZpsCK3GJs8OtE',
    [LocaleLanguage.DUTCH]: 'BPxuPmeYwF3wCmpTOGEz',
    [LocaleLanguage.GERMAN]: 'D4ooi4xscHxgkamHXkUK',
  },
  [DemoType.OPTIMIZED_SCHEDULE]: {
    [LocaleLanguage.ENGLISH]: 'NDdX4Dj67TmpGWK83mE0',
    [LocaleLanguage.DUTCH]: 'FGwQJ8jwB3nsy0R3uVut',
    [LocaleLanguage.GERMAN]: 'WuaH3SOnSz6c96b8ATVr',
  },
  [DemoType.TIME_TRACKING]: {
    [LocaleLanguage.ENGLISH]: 'HJYXrJ0Tp92s5eU3tXGq',
    [LocaleLanguage.DUTCH]: 'UirZ56eLN9nphz3obtDg',
    [LocaleLanguage.GERMAN]: '9JWDL8VRMUN65fSYmLPQ',
  },
};
